export default Object.freeze({
  INIT: 'init',
  IN_PROGRESS: 'inProgress',
  FAILED: 'failed',
  DONE: 'done'
})
